import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import PriceComparison from "../../../containers/modules/report/price-comparison";

export default function PriceComparisonRoutes(props) {
  const { authUser } = props;
  return (
    <Route
      path="price-comparison"
      index
      element={
        <AccessControl
          name={"Report Price Comparison"}
          auth={authUser}
          component={() => <PriceComparison />}
        />
      }
    ></Route>
  );
}
